import React from 'react';
export function Footer() {
  return <footer className="py-8 px-5 text-center" style={{
    background: '#0E1F1A'
  }} data-id="element-80">
      <p className="text-white/40 text-[0.8rem] mb-2" data-id="element-81">
        © 2025 Protocolo Cortisol-45. Todos los derechos reservados.
      </p>
      <p className="text-white/30 text-[0.72rem] max-w-[600px] mx-auto mb-4" data-id="element-82">
        Este producto es para fines educativos e informativos únicamente. No
        reemplaza el consejo médico profesional. Consulta a tu médico antes de
        realizar cambios significativos en tu dieta o rutina de suplementación.
      </p>
      <div className="flex justify-center gap-5 flex-wrap" data-id="element-83">
        <a href="#" className="text-white/40 text-[0.78rem] no-underline transition-colors duration-200 hover:text-oro" data-id="element-84">
          Política de Privacidad
        </a>
        <a href="#" className="text-white/40 text-[0.78rem] no-underline transition-colors duration-200 hover:text-oro" data-id="element-85">
          Términos y Condiciones
        </a>
        <a href="#" className="text-white/40 text-[0.78rem] no-underline transition-colors duration-200 hover:text-oro" data-id="element-86">
          Política de Reembolso
        </a>
        <a href="#" className="text-white/40 text-[0.78rem] no-underline transition-colors duration-200 hover:text-oro" data-id="element-87">
          Contacto
        </a>
      </div>
    </footer>;
}